import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vehicleMileage',
})
export class VehicleMileagePipe implements PipeTransform {
  transform(currentKm: number | null | undefined): string {
    const mileage = Number(currentKm);
    if (!Number.isFinite(mileage)) return 'Sin registro';

    return `${new Intl.NumberFormat('es-CO').format(mileage)} km`;
  }
}
